module.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;font-style:italic;border-left:5px solid #ccc}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-loader/lib??ref--1-1!./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css
// module id = 37
// module chunks = 0